export default __webpack_public_path__ + "static/media/grey-dislike.44ccc961.svg";